<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal" ref="loader"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <v-form v-if="showForm" v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pb-0">
        <v-container grid-list-md class="pb-0">
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <!-- <v-select
                label="Develop Partner Name"
                item-text="dev_partner_name"
                item-value="id"
                v-model="formSchema.dev_partner_id"
                :items="devPartnerList"
                :rules="[v => !!v || 'Develop partner name is required !']"
                required
              ></v-select> -->

              <v-select
                label="Development Partner Name"
                item-text="dev_partner_name"
                item-value="id"
                v-model="formSchema.dev_partner_id"
                :items="devPartnerList"
                :rules="[v => !!v || 'Develop partner name is required !']"
                required
              ></v-select>

            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Name"
                v-model="formSchema.name"
                :rules="[v => !!v || 'Name is required !']"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Designation"
                v-model="formSchema.designation_name"
                :rules="[v => !!v || 'Designation is required !']"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Phone"
                v-model="formSchema.phone"
                :rules="[v => !!v || 'Phone is required !',phoneNum]"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Email"
                v-model="formSchema.email"
                :rules="[v => !!v || 'Email is required !',email]"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Department/Division"
                v-model="formSchema.division"
                
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-checkbox v-model="formSchema.is_active" label="Active" :value="is_activeVal"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="previous">
        <v-icon>arrow_back_ios</v-icon>Previous
      </v-btn>
      <template v-if="showForm">

      <v-btn v-if="userRole.saveButton || userRole.updateButton" color="success" @click="submitOperationActivities">
        <v-icon>save</v-icon>
        {{addUpdateBtn}}
      </v-btn>

      <v-btn color="error" @click="close">
        Reset
        <v-icon>refresh</v-icon>
      </v-btn>

      </template>
    </v-card-actions>

<!-- {{userRole}} -->
    <v-card-title>
      <h2>Development Partner Contact Person Detail</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.dev_partner_name }}</td>
        <td class="text-xs-left">{{ props.item.designation_name }}</td>
        <td class="text-xs-left">{{ props.item.email }}</td>
        <td class="text-xs-left">{{ props.item.division }}</td>
        <td class="text-xs-left">
          <span v-if="props.item.is_active" class="active">Yes</span>
          <span v-else class="in-active">No</span>
        </td>
        <td class="justify-center layout px-0">
          <v-btn v-if="userRole.updateButton" icon class="mx-0" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn title="View" v-if="userRole.viewButton && userRole.updateButton<1" icon class="mx-0" @click="editItem(props.index, props.item,'view')">
            <v-icon color="teal">edit</v-icon>
          </v-btn>

          <v-btn v-if="userRole.deleteButton" icon class="mx-0" @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
let commonService = require("../../../../services/common.service");
export default {
  data() {
    return {
      valid: true,
      showForm:false,
      operation_act_id: 1,

      e1: 0,
      is_activeVal: 1,
      devPartnerList: [],

      delete_id: "",
      row_index: "",
      dialog2: false,

      SnackbarVal: {
        snackbar: false,
        color: "success",
        message: "",
      },

      formSchema: {
        id: 0,
        dev_partner_id: "",
        name: "",
        phone: "",
        designation_name: "",
        email: "",
        division: ""
      },

      /*------------- Datatable ---------------*/
      serialNumber: 0,
      sort: "",
      queryData: {
        sortBy: "id",
        descending: true,
        page: 1,
        rowsPerPage: 5,
        totalItems: 0,
        search_val: ""
      },

      search: "",
      totalDesserts: 0,
      desserts: [],
      loading: true,
      pagination: {},

      headers: [
        {
          text: "SL",
        value: ""
        },
        { text: "Name", align: "left", sortable: true, value: "name" },
        {
          text: "Dev Partner Name",
          align: "left",
          sortable: true,
          value: "dev_partner_name"
        },
        {
          text: "Designation",
          align: "left",
          sortable: true,
          value: "designation_name"
        },
        { text: "Email", align: "left", sortable: true, value: "email" },
        { text: "Division", align: "left", sortable: true, value: "division" },
        {
          text: "Active",
          align: "left",
          sortable: true,
          value: "is_active"
        },
        { text: "Action", align: "center", value: "" }
      ]
      /*------------- /Datatable ---------------*/
    };
  },

  created() {
    /*commonService.getAllData("get-dev-con-dropdown-data").then(res => {
      this.devPartnerList = res.devPartnerList;
    });*/
    let devPId = sessionStorage.getItem("dev_partner_id")  
    commonService.getAllDataById(devPId, "development-partner").then(res => {
      this.devPartnerList = res.data;

      this.formSchema.dev_partner_id = (devPId>0) ? parseInt(devPId) : '';
    });      
    

  },

  /*------------Datatable------------*/
  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    },

    userRole: function(){}
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },
    userRole() {
      let role = this.$store.getters.get_USER_ROLE_DATA;
      this.showForm = role.saveButton;
      return role;
    }
  },
  /*------------/Datatable------------*/

  methods: {
    
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();
        let devPId = sessionStorage.getItem("dev_partner_id")
        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.dev_partner_id = devPId),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "contact-person-info")
          .then(res => {
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    submitOperationActivities() {
      if (this.$refs.form.validate()) {
        this.submitForm();
      }
    },

    submitForm() {

      this.$refs.loader.loaderEnabled();

      let $this = this;
      let formSchema = $this.formSchema;

      let func_name = 'insertFormData';
      if(formSchema.id>0)
      {
        func_name = 'updateFormData';
      }
      commonService[func_name](formSchema, "contact-person").then(res => {
        
        if (res.status == 1) {
          if (res.action == "update") {
            this.showForm = this.userRole.saveButton;
            this.$set(this.desserts, this.row_index, { ...res.data });
          } else {
            $this.desserts.unshift({ ...res.data });
          }         
          $this.close();

          window.scrollTo({
            left: 0,
            top:
              document.body.scrollHeight ||
              document.documentElement.scrollHeight,
            behavior: "smooth"
          });

          setTimeout(function() {            
            $this.nextStep();
          }, 3000);

          this.SnackbarVal.color = "success";
        }
        else
        {
          this.SnackbarVal.color = "error"; 
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;

      });
    },

    nextStep() {
      this.$emit("emitForm1", 2);
    },

    previous() {
      this.$emit("emitForm2", 1);
    },

    editItem(index, item, view='') {
      if(view)
      {
        item.id = '';
      }
      this.showForm = true
      
      this.row_index = index;
      this.formSchema = { ...item };      
            
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "contact-person").then(res => {
        if (res.status == 1) {
          this.desserts.splice(row_index, 1);
          this.SnackbarVal.color = "success";
        }
        else
        {
          this.SnackbarVal.color = "error"; 
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;

        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close: function() {
        this.$refs.form.reset();
        this.formSchema.id = 0;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/project_info/development_partner/step_forms/contactPerson.vue